export function GradientBg({ color = '#2ECDFF', opacity = 5 }: { color?: string; opacity?: number }) {
  return <div className='pointer-events-none absolute inset-0' aria-hidden='true' style={{ background: `linear-gradient(to bottom, transparent, ${color}${String(opacity).padStart(2, '0')}, transparent)` }} />;
}
